import React from "react";

const InviteCard = ({ onClick }) => {
	return (
		<div style={styles.cardWrapper} onClick={onClick}>
			<div style={styles.plusContainer}>
				<div style={styles.plus}>+</div>
			</div>
			<div style={styles.inviteText}>
				Invite to
				<br />
				meeting
			</div>
		</div>
	);
};

const styles = {
	cardWrapper: {
		background: "rgba(255, 255, 255, 0.95)",
		borderRadius: "16px",
		padding: "1rem",
		textAlign: "center",
		color: "#1f2937",
		cursor: "pointer",
		transition: "transform 0.2s ease",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "space-between", // Space between plus and text
		height: "200px",
		minHeight: "200px",
		flexShrink: 0,
		boxSizing: "border-box",
		":hover": {
			transform: "translateY(-2px)",
		},
	},

	plusContainer: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},

	plus: {
		background: "transparent",
		border: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#465C9E",
		fontSize: "3rem",
		fontWeight: "300",
		lineHeight: "1",
	},

	inviteText: {
		fontWeight: "600",
		color: "#465C9E",
		fontSize: "12px",
		lineHeight: "1.3",
	},
};

export default InviteCard;
